import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";

export class Faq extends Component {
    
	constructor(props) {
        super(props);
        this.state = {isToggleOn: "1"};
    }
	
	toggleMenus = menuId => {
        this.setState({ isToggleOn: menuId });
    }
	
	render() {
        return (
            <div className="accordian px-4 pt-4 bg-white">
			    <div className={this.state.isToggleOn === "1" ? 'acr-block mb-3 open' : 'acr-block mb-3'}>
			        <button className="mb-2 position-relative d-block w-100 text-left" onClick={() => this.toggleMenus("1")}>
                        What does a ProWriter membership give me?
                    </button>
			    	<p>We provide writers with educational materials (courses, articles, mini-lessons, and more), marketing tools (a free writer portfolio designed with employers in mind), a jobs board (hand-picks writing gigs from all over the web, and hosts unique jobs), and other supportive community functions.</p>
			    </div>
				<div className={this.state.isToggleOn === "2" ? 'acr-block mb-3 open' : 'acr-block mb-3'}>
			        <button className="mb-2 position-relative d-block w-100 text-left" onClick={() => this.toggleMenus("2")}>
                        Why do you charge for this service?
                    </button>
			    	<p>ProWriter’s technology and content library are powered by a small team of passionate entrepreneurs. In order to maintain and update the tech so that it always serves our community, and in order to keep producing content that helps more writers succeed, we need help keeping the lights on!</p>
			    </div>
				<div className={this.state.isToggleOn === "3" ? 'acr-block mb-3 open' : 'acr-block mb-3'}>
			        <button className="mb-2 position-relative d-block w-100 text-left" onClick={() => this.toggleMenus("3")}>
                        If I don't like ProWriter, how do I cancel?
                    </button>
			    	<p>Simply log in to your account, click on your account settings and click "cancel my account". No need to call, email, or talk to anyone!</p>
			    </div>
				<div className={this.state.isToggleOn === "4" ? 'acr-block mb-3 open' : 'acr-block mb-3'}>
			        <button className="mb-2 position-relative d-block w-100 text-left" onClick={() => this.toggleMenus("4")}>
                        If I cancel my ProWriter account, will I lose my data?
                    </button>
			    	<p>Any features or content that is only accessible through a ProWriter membership will become inaccessible. This includes things like the jobs board, courses, and your public portfolio.</p>
			    </div>
			</div>	
		);
        
    }
}

Faq.contextType = AppContext;
export default Faq;



// WEBPACK FOOTER //
// ./src/components/general/include/Faq.js